import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { Close } from '@mui/icons-material';
import SalesPerformanceController from '../Controller/SalesPerformanceController';
import { validateSalesOrder } from 'utils/validationUtils';
import Loader from 'utils/Loader';
function SalesPerformance() {
  const {
    loadingmessage,
    orderdata,
    formData,
    user,
    cloading,
    errors,
    customeroptions,
    customerdistributor,
    selctedcustomer,
    firstLoad,
    handleAddressChange,
    handleDistributorChange,
    handleCustomerChange,
    handleSubmit,
    handleRetailerChange,
    handleRetriveSubmit,
    handleInputChange,
    handleDistributorInputChange,
    openCustomerInsightsPopup,
    setOpenCustomerInsightsPopup,
    customerInsightsData,
    customerInsightsMessage,
    barcode,
    barcodeError,
    barcodeRows,
    barcodeCount,
    isBarcodeLoading,
    handleBarcodeChange,
    handleBarcodeKeyPress,
    handleBarcodeRowToggle,
    handleBarcodeQtyChange,
    handleSubmitCheckedBarcodes,
    isSubmitLoading,
  } = SalesPerformanceController(
    {
      customer: '',
      address: '',
      retailer: 'self',
      distributor: ''
    },
    validateSalesOrder
  );

  //console.log("selctedcustomer==>",selctedcustomer)

  // console.log("user.confSpart==>"+user.confSpart);
  const confSpartValues = user.confSpart === null ? '' : user.confSpart.split(',').map((value) => parseInt(value.trim(), 10));
  const customStyles = {
    option: (provided) => ({
      ...provided,
      zIndex: 999 // Adjust the value as needed
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000 // Make sure this value is higher than the table header's z-index
    })
  };
  const formatNumber = (value) => {
    const numericValue = Number(String(value ?? '0').replace(/,/g, ''));
    if (!Number.isFinite(numericValue)) return '0';
    return numericValue.toLocaleString('en-IN');
  };
  const customerInsightTotalTarget = customerInsightsData.reduce(
    (sum, row) => sum + (Number(String(row.targetInMeters ?? '0').replace(/,/g, '')) || 0),
    0
  );
  const customerInsightTotalSales = customerInsightsData.reduce(
    (sum, row) => sum + (Number(String(row.salesInRolls ?? '0').replace(/,/g, '')) || 0),
    0
  );
  const handleCustomerSelectChange = (selectedOption) => {
    handleCustomerChange(selectedOption);
  };

  // const handleNewOrderSubmit = () => {
  //   navigate('/barcodeSO');
  // };
  return (
    <div className="bg" style={{ display: 'block' }}>
      {cloading && firstLoad ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>{loadingmessage}</span>
        </div>
      ) : null}
      <div className="cutrange">
        <span className="font20">SALES ORDER PERFORMA</span>
      </div>
      <div className="orderrow">
        

        {/* <div style={{ flex: '3', marginRight: '15px' }}>
          <label htmlFor="address">Address :</label>
          <input
            type="text"
            name="address"
            disabled={true}
            placeholder="Address"
            className="form-control inp_text"
            id="address"
            value={formData.address}
            onChange={handleAddressChange}
          />
          {errors.address == null || errors.address === '' ? <p className="no-error">.</p> : <p className="error">{errors.address}</p>}
        </div>

        {user.userVerticalId == FABRICUSER && (
          <div style={{ flex: '3', marginRight: '15px' }}>
            <label htmlFor="retailer">Retailer :</label>
            <input
              type="text"
              name="retailer"
              placeholder="Retailer"
              className="form-control inp_text"
              id="retailer"
              value={formData.retailer}
              onChange={handleRetailerChange}
            />
            {errors.retailer == null || errors.retailer === '' ? <p className="no-error">.</p> : <p className="error">{errors.retailer}</p>}
          </div>
        )} */}

      </div>






      <div className="vertical-center" style={{ marginTop: '20px' }}>
        {isBarcodeLoading ? (
          <div className="overlay">
            <Loader />
            <span style={{ marginLeft: '10px' }}>Processing barcode...</span>
          </div>
        ) : null}
        <div style={{ width: '80%', marginBottom: '15px' }}>
          <textarea
            id="barcodeInput"
            name="barcodeInput"
            value={barcode}
            className="form-control inp_text"
            placeholder="Barcode"
            onChange={handleBarcodeChange}
            onKeyDown={handleBarcodeKeyPress}
            autoFocus
            rows={3}
          />
          <div style={{ marginTop: '8px' }}>
            <p className="error">{barcodeError}</p>
          </div>
          
        </div>
        {barcodeRows && barcodeRows.length > 0 && (
  <div style={{ display: 'flex', justifyContent: 'flex-end', width: '80%', marginBottom: '15px' }}>
    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
      <span style={{ marginRight: '12px' }}>Total Scanned :</span>
      <input
        value={barcodeCount}
        readOnly
        type="text"
        name="barcodeCount"
        style={{ width: '80px', marginRight: '12px', textAlign: 'center' }}
        className="inp_text"
        id="barcodeCount"
      />
    </div>
  </div>
)}
        {barcodeRows && barcodeRows.length > 0 ? (
          
          <div className="barcode-so" style={{ width: '80%', marginTop: '0px' }}>
            <TableContainer component={Paper} style={{ width: '100%', margin: 'auto', border: '1px solid black' }}>
              <Table sx={{ minWidth: 650 }} size="small" aria-label="barcode-table">
                <TableHead>
                  <TableRow style={{ backgroundColor: '#272829', color: 'white', textAlign: 'center', fontWeight: 'bold' }}>
                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Select</TableCell>
                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Barcode</TableCell>
                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Material Description</TableCell>
                    <TableCell style={{ color: 'white', textAlign: 'left' }}>Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {barcodeRows.map((item, index) => (
                    <TableRow key={item.key || index} hover={index % 2 === 0} sx={{ backgroundColor: 'white', color: 'black', border: '1px solid black', textAlign: 'center' }}>
                      <TableCell style={{ textAlign: 'center' }}>
                        <input
                          type="checkbox"
                          checked={item.isChecked === 1}
                          onChange={() => handleBarcodeRowToggle(index)}
                        />
                      </TableCell>
                      <TableCell style={{ textAlign: 'center' }}>{item.barcode}</TableCell>
                      <TableCell style={{ textAlign: 'center' }}>{item.materialDesc}</TableCell>
                      <TableCell style={{ textAlign: 'left' }}>
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          value={item.quantity}
                          onChange={(e) => handleBarcodeQtyChange(index, e.target.value)}
                          style={{ width: '100px', textAlign: 'center', padding: '4px', border: '1px solid #333' }}
                          className="form-control inp_text"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
              <button onClick={handleSubmitCheckedBarcodes} style={{ padding: '8px 16px' }} disabled={isSubmitLoading}>
                {'Submit'}
                {isSubmitLoading && (
                  <CircularProgress size={18} color="inherit" style={{ marginLeft: '8px' }} />
                )}
              </button>
            </div>
          </div>
        ) : (
  <div
    style={{
      width: '80%',
      textAlign: 'center',
      padding: '20px',
      color: '#f8f8f8',
      marginTop: '10px'
    }}
  >
    No Data Found
  </div>
)}
      </div>

      <Dialog
        open={openCustomerInsightsPopup}
        onClose={() => setOpenCustomerInsightsPopup(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            borderRadius: 0,
            overflow: 'hidden',
            backgroundColor: '#fbfaf7',
            width: 'calc(100% - 64px)',
            maxWidth: '980px',
            mx: 'auto'
          }
        }}
      >
        <DialogTitle
          sx={{
            px: 2.5,
            py: 0,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            backgroundColor: '#fbfaf7',
            borderBottom: '1px solid #ddd7cc'
          }}
        >
         
        </DialogTitle>
        <DialogContent sx={{ p: 0, backgroundColor: '#fbfaf7' }}>
          <Box
            sx={{
              px: 2.5,
              py: 1.8,
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1.1fr 1.8fr 1fr' },
              gap: 1.5,
              backgroundColor: '#f4f1e8',
              borderBottom: '1px solid #ddd7cc'
            }}
          >
            <Box sx={{ borderRight: { xs: 'none', md: '1px solid #ddd7cc' }, pr: { xs: 0, md: 2 } }}>
              <Typography sx={{ fontSize: '0.68rem', color: '#9a9384', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                Customer Code
              </Typography>
              <Typography sx={{ fontSize: '1rem', color: '#2f312d', fontWeight: 500, lineHeight: 1.2 }}>
                {selctedcustomer?.partyCode || '-'}
              </Typography>
            </Box>
            <Box sx={{ borderRight: { xs: 'none', md: '1px solid #ddd7cc' }, px: { xs: 0, md: 2 } }}>
              <Typography sx={{ fontSize: '0.68rem', color: '#9a9384', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                Customer Name
              </Typography>
              <Typography sx={{ fontSize: '1rem', color: '#2f312d', fontWeight: 500, lineHeight: 1.2 }}>
                {selctedcustomer?.partyName || formData?.customer?.label || '-'}
              </Typography>
            </Box>
            <Box sx={{ pl: { xs: 0, md: 2 } }}>
              <Typography sx={{ fontSize: '0.68rem', color: '#9a9384', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                City
              </Typography>
              <Typography sx={{ fontSize: '1rem', color: '#2f312d', fontWeight: 500, lineHeight: 1.2 }}>
                {selctedcustomer?.city || '-'}
              </Typography>
            </Box>
          </Box>

          <Table
            size="small"
            sx={{
              '& .MuiTableCell-root': {
                borderBottom: '1px solid #ddd7cc',
                color: '#2f312d'
              }
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    width: '7%',
                    backgroundColor: '#f4f1e8',
                    color: '#8f8776',
                    fontSize: '0.66rem',
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    py: 0.8
                  }}
                />
                <TableCell
                  sx={{
                    backgroundColor: '#f4f1e8',
                    color: '#8f8776',
                    fontSize: '0.66rem',
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    fontWeight: 700,
                    py: 0.8
                  }}
                >
                  Category
                </TableCell>
                {/* <TableCell
                  sx={{
                    backgroundColor: '#f4f1e8',
                    color: '#8f8776',
                    fontSize: '0.66rem',
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    fontWeight: 700,
                    py: 0.8
                  }}
                  align="center"
                >
                  Target (Metres)
                </TableCell> */}
                <TableCell
                  sx={{
                    backgroundColor: '#f4f1e8',
                    color: '#8f8776',
                    fontSize: '0.66rem',
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    py: 0.6
                  }}
                  align="center"
                >
                  <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', minWidth: '110px' }}>
                    <Typography component="span" sx={{ fontWeight: 700, fontSize: '0.58rem', color: 'black', lineHeight: 1.05 }}>
                      FY 25-26
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        fontWeight: 700,
                        fontSize: '0.64rem',
                        color: 'black',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        lineHeight: 1.05
                      }}
                    >
                      Target (Rolls)
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customerInsightsData.length > 0 ? (
                customerInsightsData.map((row, index) => (
                  <TableRow key={row.id || `${row.categoryName}-${index}`}>
                    <TableCell sx={{ color: '#a19a8c', fontSize: '0.72rem' }}>{String(index + 1).padStart(2, '0')}</TableCell>
                    <TableCell sx={{ py: 1.15, fontSize: '0.84rem' }}>{row.categoryName || '-'}</TableCell>
                    {/* <TableCell align="center" sx={{ py: 1.15, fontSize: '0.84rem' }}>
                      {formatNumber(row.targetInMeters)}
                    </TableCell> */}
                    <TableCell align="center" sx={{ py: 1.15, fontSize: '0.84rem' }}>
                      {formatNumber(row.salesInRolls)}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 2, fontSize: '0.84rem', color: '#6f6a60' }}>
                    {customerInsightsMessage || 'No category sales data available'}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell />
                <TableCell sx={{ py: 1.25, fontSize: '0.88rem', fontWeight: 500 }}>Total</TableCell>
                {/* <TableCell align="center" sx={{ py: 1.25, fontSize: '0.88rem', fontWeight: 500 }}>
                  {formatNumber(customerInsightTotalTarget)}
                </TableCell> */}
                <TableCell align="center" sx={{ py: 1.25, fontSize: '0.88rem', fontWeight: 500 }}>
                  {formatNumber(customerInsightTotalSales)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions sx={{ px: 1.2, py: 1.2, backgroundColor: '#fbfaf7' }}>
          <Button
            variant="contained"
            onClick={() => setOpenCustomerInsightsPopup(false)}
            sx={{
              backgroundColor: '#3f4a3c',
              '&:hover': { backgroundColor: '#2f382c' }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SalesPerformance;
